import React from 'react';
import { List } from 'framework/list';
import ServiceCatalogListPageContent from 'domain/organization/serviceCatalog/List/ServiceCatalogListPageContent';
import { SERVICE_CATALOG_STATUSES, useServiceCatalogService } from 'domain/shared/serviceCatalog';

const ServiceCatalogListPage = () => {
  const { search } = useServiceCatalogService();

  return (
    <List getDataMethod={search} defaultFilter={{ status: { ne: SERVICE_CATALOG_STATUSES.ARCHIVED } }}>
      <ServiceCatalogListPageContent />
    </List>
  );
};

export default ServiceCatalogListPage;
